import React from "react";
import styles from "../ChatTestPage.module.scss";
import { ROUTES } from "../../../constants/routes";
import Footer from "../../../components/footer/Footer";
import Header from "../../../components/header/Header";
import MovieCarouselDesktop from "./MovieCarouselDesktop";
import GradientBackdrop from "../../../components/shared/GradientBackdrop/GradientBackdrop";
import ArrowUp from "../../../components/icons/chat/arrowUp";
import TitleIcon from "../../../components/icons/chat/titleIcon";
import { useChatTestPage } from "./useChatTestPage";
import ChatMessagesList from "./ChatMessagesList";

const ChatTestPageDesktop: React.FC = () => {
  const {
    t,
    messages,
    input,
    setInput,
    loading,
    sendMessage,
    stopMessage,
    inputRef,
    handleKeyDown,
    handleRefreshMessage,
    handleCopyMessage,
    hasStarted,
    lastMoviesIndex,
    showResultsColumn,
    carouselPropsBase,
    openLoginModal,
    chatMessagesRef,
    modals,
  } = useChatTestPage();

  const inputBar = (
    <div
      className={`${styles.chatWrapperInput} ${styles.fadeIn} ${
        showResultsColumn ? styles.chatWrapperWithMovies : ""
      }`}
    >
      {loading && (
        <div className={`${styles.message} ${styles.assistantMessage}`}>
          <div className={styles.messageWrapper}>
            <div className={styles.messageContent}>
              <div className={styles.assistantTyping}>
                <span />
                <span />
                <span />
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={styles.inputWrapper}>
        <textarea
          ref={inputRef}
          className={styles.input}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={t("chat_placeholder", "What would you like to watch?")}
          disabled={loading}
          maxLength={2000}
        />
        <button
          className={styles.sendBtn}
          onClick={loading ? stopMessage : sendMessage}
          disabled={!loading && !input.trim()}
        >
          {loading ? <span className={styles.stopIcon} /> : <ArrowUp />}
        </button>
        <span className={styles.textWrap}>Ai</span>
      </div>
    </div>
  );

  const resultsContent = lastMoviesIndex !== -1 && (
    <div className={styles.resultsColumn}>
      <div className={`${styles.moviesList} ${styles.fadeIn}`}>
        <MovieCarouselDesktop
          movies={messages[lastMoviesIndex].movies}
          {...carouselPropsBase}
          isMobile={false}
          openLoginModal={openLoginModal}
        />
      </div>
    </div>
  );

  return (
    <div className={styles.page}>
      <div className={styles.pageContainer}>
        <Header source={ROUTES.GID} clickHandler={() => {}} className={styles.headerWrapperFilters} />

        <GradientBackdrop />

        <div className={styles.chatArea}>
          {showResultsColumn ? (
            <div className={styles.chatSectionSplit}>
              <div className={styles.chatColumn}>
                <div className={styles.chatColumnHeader}>
                  <TitleIcon />
                  <span>{t("chat_gid", "Guide")}</span>
                </div>
                <div className={styles.chatMessages} ref={chatMessagesRef}>
                  <ChatMessagesList
                    messages={messages}
                    isMobile={false}
                    onRefreshMessage={handleRefreshMessage}
                    onCopyMessage={handleCopyMessage}
                  />
                </div>
                {inputBar}
              </div>
              {resultsContent}
            </div>
          ) : (
            <div className={`${styles.chatSectionStarted} ${hasStarted ? styles.chatSectionStartedFull : ""}`}>
              <div className={styles.spacerTop} />

              <div className={styles.chatSection}>
                {hasStarted && (
                  <div className={styles.fadeIn}>
                    <div className={styles.chatHeading}>
                      <TitleIcon />
                      <span>{t("chat_gid", "Guide")}</span>
                    </div>
                  </div>
                )}

                <ChatMessagesList
                  messages={messages}
                  isMobile={false}
                  onRefreshMessage={handleRefreshMessage}
                  onCopyMessage={handleCopyMessage}
                />
              </div>

              <div className={styles.spacerMiddle} />

              {inputBar}

              <div className={styles.spacerBottom} />
            </div>
          )}
        </div>

        {modals}

        <Footer source={""} />
      </div>
    </div>
  );
};

export default ChatTestPageDesktop;
